Object.defineProperty(exports, "__esModule", {
    value: true
});
var _object_spread = require("@swc/helpers/_/_object_spread");
var require_attachShareScopeMap = require('./attachShareScopeMap.cjs');
var require_updateOptions = require('./updateOptions.cjs');
var require_getUsedExports = require('./getUsedExports.cjs');
var require_error_codes = require('./error-codes/dist/error-codes.cjs');
var require_getShortErrorMsg = require('./error-codes/dist/getShortErrorMsg.cjs');
//#region src/consumes.ts
function consumes(options) {
    require_updateOptions.updateConsumeOptions(options);
    var chunkId = options.chunkId, promises = options.promises, installedModules = options.installedModules, webpackRequire = options.webpackRequire, chunkMapping = options.chunkMapping, moduleToHandlerMapping = options.moduleToHandlerMapping;
    require_attachShareScopeMap.attachShareScopeMap(webpackRequire);
    if (webpackRequire.o(chunkMapping, chunkId)) chunkMapping[chunkId].forEach((id)=>{
        if (webpackRequire.o(installedModules, id)) return promises.push(installedModules[id]);
        var onFactory = (factory)=>{
            installedModules[id] = 0;
            webpackRequire.m[id] = (module)=>{
                var _shareInfo_shareConfig;
                delete webpackRequire.c[id];
                var result = factory();
                var shareInfo = moduleToHandlerMapping[id].shareInfo;
                if ((shareInfo === null || shareInfo === void 0 ? void 0 : (_shareInfo_shareConfig = shareInfo.shareConfig) === null || _shareInfo_shareConfig === void 0 ? void 0 : _shareInfo_shareConfig.layer) && result && typeof result === "object") try {
                    if (!result.hasOwnProperty("layer") || result.layer === void 0) result.layer = shareInfo.shareConfig.layer;
                } catch (e) {}
                module.exports = result;
            };
        };
        var onError = (error)=>{
            delete installedModules[id];
            webpackRequire.m[id] = (module)=>{
                delete webpackRequire.c[id];
                throw error;
            };
        };
        try {
            var federationInstance = webpackRequire.federation.instance;
            if (!federationInstance) throw new Error("Federation instance not found!");
            var _moduleToHandlerMapping_id = moduleToHandlerMapping[id], shareKey = _moduleToHandlerMapping_id.shareKey, getter = _moduleToHandlerMapping_id.getter, shareInfo = _moduleToHandlerMapping_id.shareInfo, treeShakingGetter = _moduleToHandlerMapping_id.treeShakingGetter;
            var usedExports = require_getUsedExports.getUsedExports(webpackRequire, shareKey);
            var customShareInfo = _object_spread._({}, shareInfo);
            if (Array.isArray(customShareInfo.scope) && Array.isArray(customShareInfo.scope[0])) customShareInfo.scope = customShareInfo.scope[0];
            if (usedExports) customShareInfo.treeShaking = {
                usedExports,
                useIn: [
                    federationInstance.options.name
                ]
            };
            var promise = federationInstance.loadShare(shareKey, {
                customShareInfo
            }).then((factory)=>{
                if (factory === false) {
                    if (typeof getter !== "function") throw new Error(require_getShortErrorMsg.getShortErrorMsg(require_error_codes.RUNTIME_012, {
                        [require_error_codes.RUNTIME_012]: "The getter for the shared module is not a function. This may be caused by setting \"shared.import: false\" without the host providing the corresponding lib."
                    }, {
                        shareKey
                    }));
                    return (treeShakingGetter === null || treeShakingGetter === void 0 ? void 0 : treeShakingGetter()) || getter();
                }
                return factory;
            });
            if (promise.then) promises.push(installedModules[id] = promise.then(onFactory).catch(onError));
            else onFactory(promise);
        } catch (e) {
            onError(e);
        }
    });
}
//#endregion
exports.consumes = consumes; //# sourceMappingURL=consumes.cjs.map
